// extracted by mini-css-extract-plugin
module.exports = {"pill":"Pill_pill__f_IEd","pillPurple":"Pill_pillPurple__OTRyO","pillGrey":"Pill_pillGrey__M5S6w","pillOnGrey":"Pill_pillOnGrey__WvJXQ"};